<template>
   <div class="modal-body">
        <RequiredText />
        <div class="row">
            <Select2
                :parent-id="'#'+id"
                containerClass="col-4 mb-2"
                :name="`${id}-type`"
                :show-search="false"
                :multiple="false"
                :label="$t('label.type')"
                :isRequired="true"
                :placeholderText="$t('label.type')"
                v-model="formData.contract_type">
                <option v-for="type in types" :key="type.value" :value="type.value">
                    {{ type[locale]?.toUpperCase() }}
                </option>
            </Select2>
            
            <Select2
                :parent-id="'#'+id"
                containerClass="col-4 mb-2"
                :name="`${id}-employee`"
                :show-search="false"
                :multiple="false"
                :label="$t('label.employe')"
                :isRequired="false"
                :placeholderText="$t('label.employe')"
                :isDisabled="route.params.id"
                v-model="formData.employee_id">
                <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                    {{ employee.lastname }} {{ employee.firstname }}
                </option>
            </Select2>

          <div class="form-group col-4 mb-2">
            <label class="form-label fs-6 text-black">{{ $t('label.salary') }}</label>

            <VueNumberFormat v-model:value="formData.salary" class="form-control form-control-solid" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
            ></VueNumberFormat>
          </div>

            <InputDate
                :name="`${id}-date_start`"
                type="text"
                :placeholder="$t('label.start_date')"
                :parent-id="'#'+id"
                :label="$t('label.start_date')"
                :isRequired="false" size="lg"
                containerClass="col-6"
                v-model="formData.start_date"
            />

            <InputDate v-if="formData.contract_type != 'cdi'"
                :name="`${id}-date_end`"
                type="text"
                :placeholder="$t('label.end_date')"
                :parent-id="'#'+id"
                :label="$t('label.end_date')"
                :isRequired="false" size="lg"
                containerClass="col-6"
                v-model="formData.end_date"
            />
            <div class="form-group mt-5">
              <label class="form-label fs-6">{{ $t('label.notes') }}</label>
              <textarea v-model="formData.notes" class="form-control form-control-solid" rows="3"></textarea>
            </div>
            <InputFile
                containerClass="col-12 mb-2 mt-5"
                :name="`${id}-file`"
                :label="$t('label.file')"
                :isRequired="fileIsRequired"
                size="lg"
                v-model="formData.file"
                :parent-id="'#'+id"
            />
        </div>
       
    </div> 
</template>

<script setup>

import { defineProps,ref, watch } from 'vue';
import { useStore } from "vuex";
import RequiredText from "@/components/RequiredText"
import { useFormatAmount } from "@/composables/formatAmount";
import Select2 from '@/components/Select2.vue';
import InputDate from '@/components/InputDate.vue';
import InputFile from '@/components/InputFile.vue';
import { useLocales } from '@/composables/locales';
import { computed } from 'vue';
import VueNumberFormat from "vue-number-format";
import {boolean} from "yup";
import { useRoute } from 'vue-router';

const store = useStore()
const route = useRoute()
const {locale} = useLocales()

const {formatNumber} = useFormatAmount()

const props = defineProps({
    formData:{
        type:Object,
        default:{}
    },
    id:{type: String, default:"create_modal"},
    types:{
        type:Object,
        default:[]
    },
    employees:{
        type:Object,
        default:[]
    },
    fileIsRequired:{
        type:boolean,
        required:false
    }
})


const formData = ref(props.formData)

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency']) ?? {symbol: "CFA"}

watch(() => props.formData, (value) => {
    formData.value = props.formData
    formData.value.salary = parseInt(props.formData.salary)
}, { deep: true })

</script>
<style>
.end{
  display: flex; 
  justify-content: end;
}
.back{
    background-color: var(--bs-light-primary);
    border-radius: 8px;
  padding: 5px;
  width: auto;
}
</style>